import React from 'react';
import { ArrowDown, ArrowUp, ArrowUpArrowDown } from '@gravity-ui/icons';
import { Icon } from '../../../../Icon';
import { block } from '../../../../utils/cn';
import './SortIndicator.css';
const b = block('sort-indicator');
export function SortIndicator({ order }) {
    let icon;
    switch (order) {
        case 'asc':
            icon = ArrowUp;
            break;
        case 'desc':
            icon = ArrowDown;
            break;
        default:
            icon = ArrowUpArrowDown;
    }
    return (React.createElement("div", { className: b() },
        React.createElement(Icon, { data: icon, size: 14, className: b('icon') })));
}
